<template>
  <div>
    <el-card shadow="hover">
      <div slot="header">
        <el-row>
          <el-col :span="22" style="padding-top: 5px">Repeat length vs Frequency</el-col>
          <el-col :span="2">
            <span>
              <el-tooltip content="Explore more" placement="top" :enterable="false">
                <el-button circle size="mini" @click="handleModalOpen"><i class="fas fa-icon-expand"></i></el-button>
              </el-tooltip>
            </span>
          </el-col>
        </el-row>
      </div>
      <modal-unit-line-len-frequency :index="index" :series="lineOptions" height="300px"></modal-unit-line-len-frequency>
    </el-card>
  </div>
</template>

<script>
  import 'echarts/theme/shine.js';
  import IEcharts from 'vue-echarts-v3/src/full.js';
  import { store } from '../scripts/store.js';
  import { events } from '../scripts/events.js'
  import { repeatFrequency, exponentiateNum } from '../scripts/utils.js'
  import ModalUnitLineLenFrequency from '../components/ModalUnitLineLenFrequency.vue'
  const _ = require('lodash');

  export default {
    name: 'MainPlotLineLenFrequency',
    props: {
      info: Object,
      index: Number
    },
    components: { ModalUnitLineLenFrequency },
    computed: {
      lineOptions: function () {
        const plotdata = this.info.RepInfo.PlotData;
        const repeats = repeatFrequency(plotdata, 5, 'descending', 'freq').map(d => { return d.name; });
        let series = [];
        for (let rep of repeats) {
            let obj = {};
            obj.name = rep;
            obj.type = 'line';
            obj.data = [];
            obj.showSymbol = false;
            let lengths = _.range(12, 51);
            lengths.forEach(function(l) { obj.data.push(_.sum(plotdata[rep][l])); })
            series.push(obj);
        }

        series = { data: series }
        series.datatype = 'frequency';
        series.lengthType = 'bases';
        series.x = _.range(12,51);
        return series;
      }
    },
    methods: {
      handleModalOpen: function () {
        events.$emit('open-modal', 'ModalLineLenFrequency')
      }
    }
  }
</script>

<style scoped>
  .echarts {
    width: 100%;
    height: 100%;
  }
</style>